module.exports = __webpack_public_path__ + "static/media/pt3.9fc61319.jpg";